<template>
  <span
    :class="[
      'media py-3',
      {
        'highlighted': entry.highlight
      }
    ]"
  >
    <span class="rank media-left">
      <span class="d-block small">{{ entry.rank }}</span>
    </span>
    <span class="media-body">
      <span class="media">
        <span class="media-left">
          <span
            class="small profile-img mr-3"
            :style="`background-image:url(${entry.image})`"
          ></span>
        </span>
        <span class="media-body position-relative">
          <span class="entry-label position-absolute d-block">
            <span class="name d-block text-truncate">
              {{ entry.name }}
            </span>
            <span class="description d-block small">
              {{ entry.description }}
            </span>
          </span>
        </span>
      </span>
    </span>
    <span class="media-right text-nowrap text-right">
      <span
        :class="[
          'entry-total h4 mb-0 mr-1'
        ]"
      >
        {{ entry.total }}
      </span>
    </span>
  </span>
</template>

<style lang="scss" scoped>
.rank {
  width: 45px;
  text-align: center;
  margin-top: 0.6rem;
}
.entry-label {
  max-width: 90%;
}
.highlighted {
  .name,
  .description {
    font-weight: bold;
  }
}
</style>

<script>
export default {
  props: {
    entry: {
      type: Object,
      required: true
    }
  }
}
</script>